import { Box, Typography, Link } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import Heading from "./components/heading";
import Navbar from "./components/navbar";
import outshade from "./images/outshade.png";
import { Fade } from "react-awesome-reveal";
import { useMediaQuery } from "@mui/material";

const Exp = () => {
  const isNotMobile = useMediaQuery("(min-width:1024px)");
  return (
    <Box mb="10rem">
      <Heading name="Experience" />

      <Box mt="3rem" maxWidth={"80%"} ml="auto" mr="auto">
        <Fade cascade damping={0.5}>
          <Box border="1px solid #13BAD4" mb="2rem">
            <Box
              display="flex"
              flexDirection={isNotMobile ? "row" : "column"}
              justifyContent={"space-between"}
              p="0.5rem"
              borderBottom="1px solid #13BAD4"
            >
              <Typography
                color="#6AFFF0"
                fontWeight={"400"}
                fontSize="1.2rem"
                fontStyle={"italic"}
                fontFamily="Poppins"
              >
                {">> "} FullStack Development Intern - Outshade Pvt Ltd
              </Typography>
              <Typography
                color="#13BAD4"
                fontFamily="Poppins"
                fontWeight={"400"}
                fontStyle={"italic"}
              >
                Sep 2024 - Nov 2024
              </Typography>
            </Box>

            <Box
              display="flex"
              flexDirection={isNotMobile ? "row" : "column"}
              gap={isNotMobile ? "4rem" : "2rem"}
              p="2rem"
              backgroundColor="#07091B"
            >
              <img
                src={outshade}
                width={isNotMobile ? "80px" : "100px"}
                height={isNotMobile ? "80px" : "100px"}
                style={{ objectFit: "cover" }}
                alt="pic"
              />
              <Typography
                fontFamily="Poppins"
                backgroundColor="#07091B"
                fontSize={"15px"}
              >
                Developed responsive applications using MERN stack, Optimized
                user experience and reducing load times by 30%. <br />
                • Built and optimized RESTful APIs, enhancing data flow
                efficiency and reducing server response time .
                <br />
                • Collaborated with cross-functional teams in an agile
                environment, accelerating project delivery speed.
                <br />• Led code reviews and resolved technical issues,
                enhancing code stability and minimizing bugs by 15% .
                <Typography
                  sx={{
                    fontStyle: "italic",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Certificate Link:
                  <Link
                    href="https://drive.google.com/file/d/1qsavpk88vwI_eGwJqMpdR5Sy3Ck__v46/view"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      textDecoration: "none",
                      display: "inline-flex",
                      alignItems: "center",
                      marginLeft: "0.5rem",
                      position: "relative",
                      backgroundColor: "#07091B",
                      padding: "0.5rem 1rem",
                      color: "#000",
                      fontWeight: "bold",
                      borderRadius: "0.25rem",
                      boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)",
                      "&:hover": {
                        color: "#1976d2", // Optional hover color
                      },
                    }}
                  >
                    <OpenInNewIcon
                      sx={{ fontSize: "1rem", marginLeft: "0.3rem" }}
                    />
                  </Link>
                </Typography>
              </Typography>
            </Box>
          </Box>

        </Fade>
      </Box>
      <Navbar prev="" next="skills" />
    </Box>
  );
};

export default Exp;
